<script setup lang="ts">
import { resolveComponent } from 'vue';
import { THEME } from '@pkg/config/misc/theme';
import type { ModularBlock } from '@pkg/sanity-utils/types/modularContentBlocks';
import type { Button } from '@pkg/sanity-utils/types/button';
import { ButtonGroup } from '../../inner/ButtonGroup';
import ModularBlocksRenderer from '../../../frontend/ModularBlocksRenderer.vue';

interface Props {
  theme?: THEME.LIGHT | THEME.DARK;
  content?: Array<ModularBlock>;
  buttons?: Array<Button>;
}

defineProps<Props>();

/** Host app registers PartialCTA (web keeps the sibling-theme mixin). */
const PartialCTA = resolveComponent('PartialCTA');
</script>

<template>
  <component :is="PartialCTA" :theme="theme ?? THEME.LIGHT">
    <ModularBlocksRenderer :blocks="content" />
    <template v-if="buttons" #right>
      <ButtonGroup :buttons="buttons" />
    </template>
  </component>
</template>
